import posthog from "posthog-js";

export const analytics = {
  // Auth events
  signupCompleted: (props: { method: string }) => posthog.capture("signup_completed", props),
  signinCompleted: (props: { method: string }) => posthog.capture("signin_completed", props),

  // Setup events
  setupViewed: (props: { setupId: string; carName: string; trackName: string }) =>
    posthog.capture("setup_viewed", props),
  setupDownloaded: (props: { setupId: string; fileType: string; tier: string }) =>
    posthog.capture("setup_downloaded", props),
  setupZipDownloaded: (props: { setupId: string; carName: string; trackName: string }) =>
    posthog.capture("setup_zip_downloaded", props),
  setupUploaded: (props: { carName: string; trackName: string; weekNumber: number }) =>
    posthog.capture("setup_uploaded", props),

  // Package events
  packageDownloaded: (props: { packageId: string; packageName: string; includeReplays: boolean }) =>
    posthog.capture("package_downloaded", props),

  // Browse events
  setupsFiltered: (props: { filterType: string; filterValue: string }) =>
    posthog.capture("setups_filtered", props),
  driverProfileViewed: (props: { driverId: string }) =>
    posthog.capture("driver_profile_viewed", props),

  // Billing events
  pricingPageViewed: (props: { isAuthenticated: boolean }) =>
    posthog.capture("pricing_page_viewed", props),
  checkoutStarted: (props: { plan: string }) => posthog.capture("checkout_started", props),
  subscriptionActivated: (props: { plan: string }) =>
    posthog.capture("subscription_activated", props),
  subscriptionCanceled: () => posthog.capture("subscription_canceled"),
  subscriptionResumed: () => posthog.capture("subscription_resumed"),
  seriesChanged: (props: { seriesId: string; seriesName?: string }) =>
    posthog.capture("series_changed", props),

  // Landing events
  landingCtaClicked: (props: { location: string }) => posthog.capture("landing_cta_clicked", props),

  // Telemetry events
  telemetryUpload: (props: { setupId: string; carName: string; trackName: string }) =>
    posthog.capture("telemetry_upload", props),
  telemetryAnalysisComplete: (props: {
    analysisId: string;
    userLapTime: number;
    refLapTime: number;
  }) => posthog.capture("telemetry_analysis_complete", props),
  telemetryAiReportGenerated: (props: { analysisId: string }) =>
    posthog.capture("telemetry_ai_report_generated", props),
};
